/**
 * Google Maps embed URL for a free-text address. No API key.
 * Blank or whitespace-only addresses return ''.
 */
export function mapEmbedSrc(address) {
  const q = String(address || '').replace(/\s+/g, ' ').trim();
  if (!q) return '';
  return `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=15&output=embed`;
}
